import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { ArbitrumIcon } from "../Icon/Chains/ArbitrumIcon";
import { AvalancheIcon } from "../Icon/Chains/AvalancheIcon";
import { BinanceIcon } from "../Icon/Chains/BinanceIcon";
import { EthereumIcon } from "../Icon/Chains/EthereumIcon";
import { FantomIcon } from "../Icon/Chains/FantomIcon";
import { OptimismIcon } from "../Icon/Chains/OptimismIcon";
import { PolygonIcon } from "../Icon/Chains/PolygonIcon";
import { ChainIconOption } from "./IconChain.types";
const IconChain = React.memo((props) => {
    const { icon } = props;
    const commonProps = {
        fontSize: "small",
        color: "inherit",
    };
    switch (icon) {
        case ChainIconOption.ARBITRUM:
            return _jsx(ArbitrumIcon, { ...commonProps });
        case ChainIconOption.AVALANCHE:
            return _jsx(AvalancheIcon, { ...commonProps });
        case ChainIconOption.BSC:
            return _jsx(BinanceIcon, { ...commonProps });
        case ChainIconOption.ETHEREUM:
            return _jsx(EthereumIcon, { ...commonProps });
        case ChainIconOption.FANTOM:
            return _jsx(FantomIcon, { ...commonProps });
        case ChainIconOption.OPTIMISM:
            return _jsx(OptimismIcon, { ...commonProps });
        case ChainIconOption.POLYGON:
            return _jsx(PolygonIcon, { ...commonProps });
        default:
            return _jsx(_Fragment, {});
    }
});
export { IconChain };
//# sourceMappingURL=IconChain.js.map